import * as React from "react"
import Metadata from "../../contentful/Metadata"
import { theme } from "../../theme"
import { HorizontalSpacer } from "../../atoms/spacers"
import ContactUsForm from "../../organisms/ContactUsForm"
import { ContentfulLiveUpdates } from "../../../graphql/contentful/client"
import { usePageCampaign } from "../../../hooks/useCampaignPage"
import RichText from "../../molecules/RichText"
import { useContentfulLiveUpdates } from "@contentful/live-preview/react"
import { useParams } from "react-router-dom"
import CampaignHeroSection from "./CampaignHeroSection"
import DiscoverProducts from "./DiscoverProducts"
import H1 from "../../atoms/typography/H1"
import LoadingSpinner from "../../atoms/LoadingSpinner"
import MissingPage from "../404Page"

const CampaignPage: React.FC<{ slug: string }> = ({ slug }) => {
  const { campaign: unliveCampaign, error, loading, query } = usePageCampaign(slug)
  const campaign = useContentfulLiveUpdates(unliveCampaign, { query })

  if (error) {
    return <H1>{error.message}</H1>
  }

  if (!loading && !campaign) {
    return <MissingPage />
  }

  if (loading || !campaign) {
    return (
      <div style={{ backgroundColor: theme.colors.greyLighter }}>
        <CampaignHeroSection />
        <HorizontalSpacer spacing={3} />
        <LoadingSpinner />
        <HorizontalSpacer spacing={3} />
      </div>
    )
  }

  const { metadata, title, subtitle, disclaimer, cost, image, contactFormTitle, content, color, sheet } = campaign

  return (
    <div style={{ backgroundColor: theme.colors.greyLighter }}>
      <Metadata {...metadata} />
      <CampaignHeroSection {...{ cost, image, title, subtitle, disclaimer, color, sheet }} />
      <HorizontalSpacer spacing={3} />
      {content && <RichText rtf={content} />}
      <HorizontalSpacer spacing={3} />
      <div id="contact-us">
        <ContactUsForm title={contactFormTitle} />
      </div>
      <DiscoverProducts />
    </div>
  )
}

export const CampaignPageWithSlug = () => {
  const { slug } = useParams()

  return (
    <ContentfulLiveUpdates>
      <CampaignPage slug={slug!} />
    </ContentfulLiveUpdates>
  )
}

export default CampaignPageWithSlug
